import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-nav', 'search', 'Meklēšana');
Labels.set('ui-nav', 'searchOpen', 'Atvērt meklēšanu');
Labels.set('ui-nav', 'searchClose', 'Aizvērt meklēšanu');
